import _ from "lodash";

export function handle (characteristics, maxLevel)
{
	// clone deep or otherwise the set gets "globally" manipulated
	characteristics = _.cloneDeep(characteristics);

	handleList(characteristics, 0, maxLevel);

	return characteristics;
}

function handleList (characteristics, level, maxLevel)
{
	_.forEach(characteristics, characteristic =>
	{
		if (level >= maxLevel)
		{
			characteristic.children = [];
		}

		handleList(characteristic.children, level + 1, maxLevel);
	});
}
